/* eslint-disable no-undef */
const TOAST_ID = "myToast";
const DEFAULT_DURATION_MS = 2000;

const ensureToastElement = () => {
  let toastElement = document.getElementById(TOAST_ID);
  if (toastElement) {
    return toastElement;
  }

  toastElement = document.createElement("div");
  toastElement.id = TOAST_ID;
  toastElement.className =
    "toast align-items-center text-white bg-primary border-0 position-fixed bottom-5";
  toastElement.setAttribute("role", "alert");
  toastElement.setAttribute("aria-live", "assertive");
  toastElement.setAttribute("aria-atomic", "true");
  toastElement.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">
        <strong></strong>
      </div>
      <button
        type="button"
        class="btn-close btn-close-white me-2 m-auto"
        data-bs-dismiss="toast"
        aria-label="Close"
      ></button>
    </div>
  `;
  document.body.appendChild(toastElement);
  return toastElement;
};

/**
 * Show a Bootstrap toast using the shared #myToast element (OrderAgain pattern).
 * @param {string} message
 * @param {number} [durationMs]
 */
export const showToast = (message, durationMs = DEFAULT_DURATION_MS) => {
  if (!message) {
    return;
  }

  const toastElement = ensureToastElement();
  const messageNode = toastElement.querySelector(".toast-body strong");
  if (messageNode) {
    messageNode.textContent = message;
  }

  const toast = new bootstrap.Toast(toastElement);
  toast.show();
  setTimeout(() => {
    toast.hide();
  }, durationMs);
};
